export const environment = {
    production: true,
    apiBaseURL: 'https://api.plattacloud.fi/api',
};